import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Axios from 'axios';
import { Menu, X, User, LogOut } from "lucide-react";

export const Navbar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchProtected = async () => {
      try {
        const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
        if (response.data.status === 'success') {
          props.setLoginStatus(true);
          props.setUEmail(response.data.email);
        } else {
          props.setLoginStatus(false);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchProtected();
  }, []);

  const logout = () => {
    Axios.get("https://mygamename.com/php/logout.php").then(() => {
      localStorage.removeItem('token');
      props.setLoginStatus(false);
      try { props.setUEmail(''); } catch {}
      navigate('/login');
    });
  };

  const navLinks = [
    { to: '/create', label: 'Create' },
    { to: '/names',  label: 'Names'  },
    { to: '/about',  label: 'About'  },
  ];

  return (
    <nav className="w-full bg-[#111111] border-b border-[#222222] z-50 relative">
      <div className="max-w-5xl mx-auto px-5 h-14 flex items-center justify-between">

        {/* Brand */}
        <Link to="/" className="nav-brand text-[#F5F5F5] text-lg hover:text-[#8B5CF6] transition-colors">
          My<span className="text-[#8B5CF6]">Game</span>Name
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `nav-link text-sm transition-colors ${isActive ? 'text-[#8B5CF6]' : 'text-[#F5F5F5]/70 hover:text-[#F5F5F5]'}`
              }
            >
              {label}
            </NavLink>
          ))}
        </div>

        {/* Desktop auth */}
        <div className="hidden md:flex items-center">
          {props.loginStatus ? (
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="w-8 h-8 rounded-full bg-[#8B5CF6] hover:bg-[#7C3AED] flex items-center justify-center transition-colors"
              >
                <User size={15} className="text-[#F5F5F5]" />
              </button>
              {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-36 bg-[#1a1a1a] border border-[#333333] rounded-lg shadow-lg overflow-hidden z-50">
                  <button
                    onClick={() => { setDropdownOpen(false); logout(); }}
                    className="w-full flex items-center gap-2 px-3 py-2.5 text-sm text-[#F5F5F5]/70 hover:bg-[#222222] hover:text-[#8B5CF6] transition-colors"
                  >
                    <LogOut size={14} />
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link
              to="/login"
              className="nav-link flex items-center gap-1.5 text-sm bg-[#8B5CF6] hover:bg-[#7C3AED] text-[#F5F5F5] px-4 py-1.5 rounded-lg transition-colors"
            >
              <User size={15} />
              Login
            </Link>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-[#F5F5F5]/70 hover:text-[#8B5CF6] transition-colors"
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-[#1a1a1a] border-t border-[#222222] px-5 py-4 flex flex-col gap-1">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              onClick={() => setIsOpen(false)}
              className="nav-link text-sm text-[#F5F5F5]/70 hover:text-[#8B5CF6] py-2.5 border-b border-[#222222] transition-colors"
            >
              {label}
            </Link>
          ))}
          <div className="pt-3">
            {props.loginStatus ? (
              <button
                onClick={() => { setIsOpen(false); logout(); }}
                className="nav-link flex items-center gap-2 text-sm text-[#F5F5F5]/70 hover:text-[#8B5CF6] transition-colors"
              >
                <LogOut size={15} />
                Logout
              </button>
            ) : (
              <Link
                to="/login"
                onClick={() => setIsOpen(false)}
                className="nav-link flex items-center gap-2 text-sm bg-[#8B5CF6] hover:bg-[#7C3AED] text-[#F5F5F5] px-4 py-2 rounded-lg w-fit transition-colors"
              >
                <User size={15} />
                Login
              </Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};
